import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import "./LogoutButton.scss";

const LogoutButton = () => {
  const { logout } = useAuth0();
  const loginStyle = {fontFamily: "Space Mono", backgroundColor: "#CE0707", color: "white", paddingLeft: "27px", paddingRight: "27px"}
  
  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <button className="button is-smaller logout-btn" style={loginStyle} onClick={handleLogout}>
      <i className="fas fa-sign-out" style={{margin: "20px"}}></i>
      Log Out
    </button>    
  );
};

export default LogoutButton;